import React, { useState } from 'react';

import { Button, Input, Modal, Select, showToast } from '@attentive-platform/stem-ui';

import { ROLE_OPTIONS, MODAL_MODE } from './constants';

const MemberFormModal = ({ show, mode, currentEmail, initialRole, onClose, onSubmit, loading }) => {
  const [newEmail, setNewEmail] = useState('');
  const [bidRole, setBidRole] = useState('');

  const isTransfer = mode === MODAL_MODE.TRANSFER;
  const heading = isTransfer ? 'Transfer seat' : 'Add new user';
  const submitLabel = isTransfer ? 'Transfer & Remove' : 'Send an invite';
  const effectiveRole = bidRole || initialRole;

  const handleClose = () => {
    setNewEmail('');
    setBidRole('');
    onClose();
  };

  const handleSubmit = () => {
    if (!newEmail) {
      showToast('Please enter an email address', 'error');
      return;
    }
    if (!effectiveRole) {
      showToast('Please select a user type', 'error');
      return;
    }
    onSubmit({ newEmail, bidRole: effectiveRole }, () => {
      setNewEmail('');
      setBidRole('');
    });
  };

  return (
    <Modal
      show={show}
      heading={heading}
      onClose={handleClose}
      content={
        <div className='flex flex-col gap-4 m-3 w-[400px]'>
          {isTransfer && (
            <div>
              <label className='block text-xs text-gray-900 mb-1 text-left'>Current user email address</label>
              <Input value={currentEmail} className='w-full' disabled placeholder='Current user email address' />
            </div>
          )}

          <div>
            <label className='block text-xs text-gray-900 mb-1 text-left'>
              {isTransfer ? 'New user email address' : 'Email address'}
            </label>
            <Input
              value={newEmail}
              className='w-full'
              placeholder={isTransfer ? 'Enter new user email address' : 'Enter email address'}
              onChange={e => setNewEmail(e.target.value)}
            />
          </div>

          <div>
            <label className='block text-xs text-gray-900 mb-1 text-left'>User type</label>
            <Select
              size='large'
              items={ROLE_OPTIONS}
              value={effectiveRole}
              onChange={setBidRole}
              placeholder='Select user type'
            />
          </div>

          <div className='flex justify-end gap-2 pt-3'>
            <Button size='medium' variant='outlined' onClick={handleClose}>
              Cancel
            </Button>
            <Button color='primary' size='medium' onClick={handleSubmit} loading={loading}>
              {submitLabel}
            </Button>
          </div>
        </div>
      }
    />
  );
};

export default MemberFormModal;
